export let sendFeedbackDialogTitle = "N6BZNb";
export let sendFeedbackEmailSubject = "t$KLee";
export let sendFeedbackEmailContentStart = "E3Aird";
export default {sendFeedbackDialogTitle,sendFeedbackEmailSubject,sendFeedbackEmailContentStart};